import IconBuilding from "../icons/building.svg";
import IconBedSize from "../icons/bed-size.svg";
import IconTwoPeople from "../icons/two-people.svg";

import IconBBQ from "../icons/bbq.svg";
import IconCar from "../icons/car.svg";
import IconCleaning from "../icons/cleaning.svg";
import IconConditioner from "../icons/conditioner.svg";
import IconDishwasher from "../icons/dishwasher.svg";
import IconHealter from "../icons/healter.svg";
import IconMailBox from "../icons/mailbox.svg";
import IconSilverWare from "../icons/silver-ware.svg";
import IconSwimming from "../icons/swimming.svg";
import IconTV from "../icons/tv.svg";
import IconWasherDryer from "../icons/washer-dryer.svg";
import IconWifi from "../icons/wifi.svg";
import IconNote from "../icons/note.svg";
import IconMorning from "../icons/morning.svg";
import IconAfternoon from "../icons/afternoon.svg";
import IconEvening from "../icons/evening.svg";
import IconWallet from "../icons/wallet.svg";
import IconHome1Line from "../icons/home-1-line.svg";
import IconIdCard from "../icons/id-card.svg";
import IconSheet from "../icons/sheet.svg";
import IconLock from "../icons/lock.svg";
import IconHistoryNote from "../icons/history-note.svg";
import IconCard from "../icons/card.svg";

type Props = {
    className?: string,
    code: string,
    fontSize?: number
};

/**
 * @example  <Icon color="#f0f" code="Edit"/>
 */
function Icon({ className = "text-black", code = "Edit", fontSize = 24 }: Props) {
    let X = null
    if (code === "building") { X = IconBuilding }
    if (code === "bed-size") { X = IconBedSize }
    if (code === "two-people") { X = IconTwoPeople }
    if (code === "bbq") { X = IconBBQ }
    if (code === "car") { X = IconCar }
    if (code === "cleaning") { X = IconCleaning }
    if (code === "conditioner") { X = IconConditioner }
    if (code === "dishwasher") { X = IconDishwasher }
    if (code === "healter") { X = IconHealter }
    if (code === "mailbox") { X = IconMailBox }
    if (code === "silver-ware") { X = IconSilverWare }
    if (code === "swimming") { X = IconSwimming }
    if (code === "tv") { X = IconTV }
    if (code === "washer-dryer") { X = IconWasherDryer }
    if (code === "wifi") { X = IconWifi }
    if (code === "note") { X = IconNote }
    if (code === "morning") { X = IconMorning }
    if (code === "afternoon") { X = IconAfternoon }
    if (code === "evening") { X = IconEvening }
    if (code === "wallet") { X = IconWallet }
    if (code === "home-1-line") { X = IconHome1Line }
    if (code === "id-card") { X = IconIdCard }
    if (code === "sheet") { X = IconSheet }
    if (code === "lock") { X = IconLock }
    if (code === "history-note") { X = IconHistoryNote }
    if (code === "card") { X = IconCard }


    if (X) {
        return <i className={`iconfont icon-${code} ` + className} style={{ fontSize }}>
            <span style={{ height: "1em", width: "1em", display: "inline-block" }}>
                <X />
            </span>
        </i>
    }
    return <i className={`iconfont icon-${code} ` + className} style={{ fontSize }}></i>
}
export default Icon;